import React, { Suspense } from 'react';
// import { registerLocale, setDefaultLocale } from 'react-datepicker';
import { BrowserRouter as Router, Switch } from 'react-router-dom';
import ErrorBoundary from '../components/ErrorBoundary';
import Error404 from '../components/pages/Error404';
import SignCancel from '../components/sign/SignCancel';
import SignNext from '../components/sign/SignNext';
import LoadingBilagSky from '../components/UI/LoadingBilagSky';
import Video from '../components/video/Android';
import Invoice from '../components/video/Invoice';
import PaymentDNBAndroid from '../components/video/PaymentDNBAndroid';
import PaymentSP1Android from '../components/video/PaymentSP1Android';
import AddComment from '../components/webview/add-comment-task';
import EditComment from '../components/webview/edit-comment-task';
import EditDescription from '../components/webview/edit-description-task';
import ConsentSignant from '../components/ztl/sign/consent/signant';
import ZtlSignPayment from '../components/ztl/sign/payment';
import ZtlCancelPayment from '../components/ztl/sign/cancel';

import OnboardingCallback from '../components/ztl/sign/onboarding';
import { ErrorRoutes, RouterNoPrefix, RoutesUrl } from '../constants/routes.constants';
import UnAuthorized from '../components/pages/UnAuthorized';

const Routes = React.lazy(() => import('./Routes'));
// const AuthContainer = React.lazy(() => import('./AuthContainer'));
const PublicRoute = React.lazy(() => import('./PublicRoute'));
// ==== Route Config ====
const publicRoutes = [
  { path: RouterNoPrefix.VideoAndroid, component: Video },
  { path: RouterNoPrefix.EditDescriptionTask, component: EditDescription },
  { path: RouterNoPrefix.CreateCommentTask, component: AddComment },
  { path: RouterNoPrefix.EditCommentTask, component: EditComment },
  { path: RouterNoPrefix.VideoPaymentDNBAndroid, component: PaymentDNBAndroid },
  { path: RouterNoPrefix.VideoPaymentSP1Android, component: PaymentSP1Android },
  { path: RouterNoPrefix.Invoice, component: Invoice },
  { path: RoutesUrl.SignNext, component: SignNext },
  { path: RoutesUrl.SignCancel, component: SignCancel },
  { path: RouterNoPrefix.ConsentSignant, component: ConsentSignant },
  { path: RouterNoPrefix.ZtlPaymentCallBack, component: ZtlSignPayment },
  { path: RouterNoPrefix.ZtlPaymentCancelCallback, component: ZtlCancelPayment },
  { path: RouterNoPrefix.OnboardingCallback, component: OnboardingCallback },
  { path: ErrorRoutes.UnAuthorized, component: UnAuthorized, exact: true },
  { path: ErrorRoutes.Notfound, component: Error404 },
];

function App() {
  return (
    <Router>
      <ErrorBoundary>
        <Suspense fallback={<LoadingBilagSky />}>
          <Switch>
            {publicRoutes.map(({ path, component, exact = true }, idx) => (
              <PublicRoute
                key={idx}
                restricted={false}
                path={path}
                exact={exact}
                component={component}
              />
            ))}
            {/* Routes */}
            <Routes />
            {/* Catch-all 404 */}
            <PublicRoute component={Error404} />
          </Switch>
        </Suspense>
      </ErrorBoundary>
    </Router>
  );
}

export default App;
